<div *ngIf="settings$ | async as directionOfAmount" class="flex flex-col gap-6">
	<app-direction-of-fee-dropdown
		[currentDirectionOfFee]="directionOfAmount.location"
		label="Display Line Item(s) In"
		fieldToUpdate="titleInsurance.directionOfAmount.location"
		(directionOfFeeChange)="setLocation($event, directionOfAmount)"
	/>

	@if (directionOfAmount.location !== doaLocations.NONE) {
		<div class="grid grid-cols-2 gap-2">
			<app-select
				[required]="true"
				label="Fee Amount"
				[ngModel]="directionOfAmount.operator"
				(ngModelChange)="setOperator($event, directionOfAmount)"
				[testHook]="testHooks.FeeAmountSelect"
			>
				@for (option of directionAmountOptions; track option.value) {
					<option
						[value]="option.value"
						[testHook]="testHooks.DirectionOfAmountOption"
					>
						{{ option.label }}
					</option>
				}
			</app-select>

			<app-input
				class="self-end"
				[autofocus]="focusInput_()"
				*ngIf="directionOfAmount.operator === 'less than'"
				type="cents"
				[ngModel]="directionOfAmount.amount"
				(debounce)="setAmount($event, directionOfAmount)"
				appGreaterThanCentAmount="{{ 0 }}"
				[testHook]="testHooks.LessThanInput"
			/>

			<app-input
				class="self-end"
				*ngIf="directionOfAmount.operator === 'greater than'"
				type="cents"
				[ngModel]="directionOfAmount.amount"
				(debounce)="setAmount($event, directionOfAmount)"
				[testHook]="testHooks.GreaterThanInput"
			/>
		</div>
	}
</div>
